import React, { useState, useEffect, Fragment } from "react";
import { images } from "../../common/Images";
import "../../styles/styles.css";
import Footer from "./Footer";
import Header from "./Header";
import { Button, Carousel, Form, Modal } from "antd";
import "../../styles/Home.css";
import { ApiCall, Colors, Web_url } from "../../common/Const";
import Collection from "./homeComponents/Collection";
import Budget from "./homeComponents/Budget";
import BestSeller from "./homeComponents/BestSeller";
import Exclusive from "./homeComponents/Exclusive";
import Categories from "./homeComponents/Categories";
import Offers from "./homeComponents/Offers";
import PromoVideos from "./homeComponents/PromoVideos";
import Review from "./homeComponents/Review";
import Subscribe from "./homeComponents/Subscribe";
import Trending from "./homeComponents/Trending";
import String from "../../lang/String";
import { MutatingDots } from "react-loader-spinner";
import { useSelector } from "react-redux";
import EncryptDecrypt from "../../common/Crypto";
import SkeletonEffect from "./homeComponents/SkeletonEffect";
import store from "../../redux/Store";
import TextBox from "./TextBox";
import TextArea from "./TextArea";
import { toast, ToastContainer } from "react-toastify";

function Home() {
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const [HomeData, setHomeData] = useState([]);
  const [cusId, setcusId] = useState(0)
  const [LocalValue, setLocalValue] = useState(0)
  const user = useSelector((state) => state.auth.user);
  const userData = localStorage.getItem("user_profile");
  const [settings, setSettings] = useState({});
  const [zipCode, setZipCode] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, inputChange] = useState("");
  const [firstError, setfirstError] = useState("");
  const [lastError, setlastError] = useState("");
  const [emailError, setemailError] = useState("");
  const [phone_no, setPhone_no] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [location,changeLocation] = useState('')
  const [locationError,setLocationError] = useState('')
   const [BtnLoad, setBtnLoad] = useState(false);
  const DecryptData = async () => {
    let type = "decrypt"
    let format = "text"
    let id = localStorage.getItem('customerId');
    await EncryptDecrypt(id, type, format, (response) => {
      setcusId(response)
    })
  }

  

  const homeSection = () => {
    const params =
      user && user.id > 0
        ? { customer_id: user.id }
        : cusId && cusId > 0
        ? { customer_id: cusId }
        : {};

    ApiCall("homeSection", params)
      .then((data) => {
        if (data.message == "Success") {
          setHomeData(data.result);
          // console.log(data.result[4]);
          if(data.result.length > 0 && data.result[4].data.length > 0){
            store.dispatch({ type: "exclusiveData", payload: data.result[4].data });
          }
        }
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    setTimeout(() => {
      return (
        <div className="d-flex align-items-center justify-content-center ban-box">
          <MutatingDots
            height="100"
            width="100"
            color={Colors.Base_color}
            secondaryColor={Colors.Base_color}
            radius="12.5"
            ariaLabel="mutating-dots-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
        </div>
      )
    }, 2000);
    homeSection();
    store.dispatch({ type: "ClearMenu" });
    store.dispatch({ type: "ClearParams" });
    store.dispatch({ type: "ClearSort" });
  }, [cusId])

   useEffect(() => {
      ApiCall("appsetting").then((data) => {
        if (data.message === "Success") {
          setSettings(data.result);
        }
      });
    }, []);

  useEffect(() => {
    DecryptData();
    // homeSection();
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if(localStorage.getItem('customerId') != null){
      setLocalValue(localStorage.getItem('customerId'))
    }
     
  }, [localStorage.getItem('customerId')])

    const prefixImg = (src) => {
      return (
        <div
          className="pre-icon"
          style={{   borderRight: src != 'comment-dots' &&  `2px solid ${Colors.Base_color}` }}
        >
          {/* <i class="fa-solid fa-envelope"></i> */}
          {/* {src == 1 ?  */}
          <i class={`fa-${(src != 'phone' && src != 'people-group' && src != 'location-dot' && src != 'comment-dots'  && src != 'envelope' && src != 'user' ) ? 'regular' : 'solid'} fa-${src} d-flex justify-content-center align-items-center`} style={{height: '25px', width: '25px', color: Colors.Base_color}}></i> 
          {/* <img
            src={src}
            className=""
            style={{ objectFit: "contain" }}
            height={25}
            width={25}
          />
           } */}
          
        </div>
      );
    };

    const loginValidation = () => {
      let isValid = true;
      if (firstName === "") {
        isValid = false;
        setfirstError("Enter your name");
      } else {
        // isValid = true;
        setfirstError("");
      }
  
      if (email == "") {
        console.log("emal")
        isValid = false;
        setemailError("Enter your email");
      } else {
        // console.log("emal else")
        setemailError("");
        // isValid = true;
      }
      if (email != "") {
        let lastAtPos = email.lastIndexOf("@");
        let lastDotPos = email.lastIndexOf(".");
        if (
          !(
            lastAtPos < lastDotPos &&
            lastAtPos > 0 &&
            email.indexOf("@@") == -1 &&
            lastDotPos > 2
          )
        ) {
          isValid = false;
          setemailError("Enter valid Email");
          // console.log("email val")
        }
      }else{
        // isValid = true;
        // setemailError("");
        // console.log("email val else")
      }
  
      if (phone_no === "") {
        isValid = false;
        setPhoneError("Phone Number is required");
      } else {
        // isValid = true;
        setPhoneError("");
      }
  
      if (
        (phone_no && phone_no.length > 10) ||
        (phone_no && phone_no.length < 10)
      ) {
        isValid = false;
        setPhoneError("Enter valid Phone number");
      }else{
        // isValid = true;
        // setPhoneError("");
      }
      if (location === "") {
        isValid = false;
        setLocationError("Enquiry is required");
      } else {
        // isValid = true;
        setLocationError("");
      }
  
      return isValid;
    };


    const handleSubmit =(e) =>{
      e.preventDefault();
    if (!loginValidation()) {}else{
      
      setBtnLoad(true);
      const enquryData = {
                name: firstName,
                email: email,
                phone_number: phone_no,
                content: location,
              };
      
              ApiCall("add_enquiry", enquryData)
                .then((data) => {
                  console.log("response -->", data);
                  setBtnLoad(false);

                  toast.success("We have recieved your enquiry.Our team will contact you soon!", {
                                  position: "top-right",
                                  autoClose: 3000,
                                  hideProgressBar: false,
                                  closeOnClick: true,
                                  pauseOnHover: true,
                                  draggable: true,
                                  progress: undefined,
                                  theme: "colored",
                                });
                                document.querySelector('.btn-close').click();
                                setFirstName('')
                                setPhone_no('')
                                inputChange('')
                                changeLocation('')
                }).catch((err) =>{
                  console.log(err)
                  setBtnLoad(false)
                });
    }
    }
  return(
    <>
      <Header windowSize={windowSize} display={true} make={true} />
      <div
        className="d-flex flex-column"
        style={{ backgroundColor: Colors.bg_color }}
      >
        {/* Banner */}
        <Carousel autoplay>
          {HomeData.length > 0 && HomeData[0].data.length > 0 ? (
            HomeData[0].data.map((data) => {
              return (
                <Fragment key={data.id}>
                <div className="ban-box">
                  <img
                    className="ban-box"
                    src={Web_url.Domain_url + data.image}
                  />
                </div>
                </Fragment>
              );
            })
          ) : (
            // <div className="ban-box">
            //   <img className="img-fluid" src={images.banner2} />
            // </div>
            <SkeletonEffect className={"ban-box"} count={1} />
          )}
        </Carousel>

        {/* box */}
        <div className="container">
        <div className={ windowSize > 540 ? "mx-3 my-5" : "mx-0 my-3"}>
          <div className="row d-flex gap-3 align-items-center justify-content-center">
            {String.home_box.map((data) => {
              return (
                <Fragment key={data}>
                <div
                  className={windowSize > 540 ? "col-xl-3 col-xxl-3 col-lg-3 col-md-3 col-2 d-flex flex-column justify-content-center align-items-center ad-box px-3 py-4" : "col-xl-4 col-xxl-4 col-lg-3 col-md-4 col-4 d-flex flex-column justify-content-center align-items-center ad-box px-2 py-2"}
                  style={{ backgroundColor: Colors.Base_color }}
                >
                  <img
                    src={data.icon}
                    // width="50"
                    // height="50"
                    alt="icons"
                    className={ windowSize > 540 ? "mt-2 img-fluid img-box-first" : "img-fluid img-box-first"}
                    style={{
                      width: windowSize > 540 ? '50px' : '40px' 
                    }}
                  />
                  <strong
                    className={windowSize > 540 ? "text-center mt-2 box-text-first" : "text-center mt-1 box-text-first"}
                    style={{ color: Colors.white_color, 
                      fontSize: windowSize > 540 ? '19px' : '15px' 
                    }}
                  >
                    {data.text}
                  </strong>
                  <strong
                    className={windowSize > 540 ? "text-center mb-2 box-text-first" : "text-center mb-1 box-text-first"}
                    style={{ color: Colors.white_color,
                      fontSize: windowSize > 540 ? '16px' : '10px'  }}
                  >
                    {data.last_text}
                  </strong>
                </div>
                </Fragment>
              );
            })}
          </div>
        </div>
        </div>
        

        {/* Collections */}
        {/* <Collection
          windowSize={windowSize}
          collectionData={
            HomeData.length > 0 && HomeData[1].data.length > 0
              ? HomeData[1].data
              : null
          }
        /> */}

        {/* Shop on Budget */}
        <Budget
          budgetData={
            HomeData.length > 0 && HomeData[2].data.length > 0
              ? HomeData[2].data
              : null
          }
        />

        {/* Best Seller */}
        {/* <BestSeller
          windowSize={windowSize}
          sellerData={
            HomeData.length > 0 && HomeData[3].data.length > 0
              ? HomeData[3].data
              : null
          }
        /> */}

        {/* Exclusive */}
        {/* <Exclusive
          exclusiveData={
            HomeData.length > 0 && HomeData[4].data.length > 0
              ? HomeData[4].data
              : null
          }
        /> */}

        {/* Trending */}
        <Trending
          windowSize={windowSize}
          trendingData={
            HomeData.length > 0 && HomeData[5].data.length > 0
              ? HomeData[5].data
              : null
          }
        />

        {/* Categories */}
        <Categories
          categoryData={
            HomeData.length > 0 && HomeData[6].data.length > 0
              ? HomeData[6].data
              : null
          }
        />

        {/* Offers */}
        <Offers
          windowSize={windowSize}
          offerData={
            HomeData.length > 0 && HomeData[7].data.length > 0
              ? HomeData[7].data
              : null
          }
        />

        {/* PromoVideos */}
        <PromoVideos
          promoData={
            HomeData.length > 0 && HomeData[8].data.length > 0
              ? HomeData[8].data
              : []
          }
        />

        {/* Review */}
        <Review
          windowSize={windowSize}
          reviewData={
            HomeData.length > 0 && HomeData[9].data.length > 0
              ? HomeData[9].data
              : null
          }
        />


<Subscribe
          windowSize={windowSize}
        />
      </div>

      <Footer windowSize={windowSize} />
{/*       
      <img src={require('../../assets/contact.png')} style={{
          width:'70px',
          position:'fixed',
          bottom:'90px',
          right:'10px',
          cursor:'pointer',
          zIndex: 100
        }} 
        data-bs-toggle="modal"
        data-bs-target="#locationModal"
         /> */}

        <div style={{
          padding: '10px',
          borderTopLeftRadius: '10px',
          borderBottomLeftRadius: '10px',
          position: 'fixed',
          top: '50%',
          right: '0px',
          transform: 'translateY(-50%)',
          cursor: 'pointer',
          zIndex: 100,
          background: Colors.Base_color
         }}
         data-bs-toggle="modal"
         data-bs-target="#locationModal">
         <img src={require('../../assets/enquiry.png')} style={{
           width:'30px',
           height:'200px',
           objectFit:'cover'
         }} />
        </div>

      <a href={`https://wa.me/${settings.whatsapp}`} target="_blank" rel="noopener noreferrer" style={{
          width:'60px',
          position:'fixed',
          bottom:'10px',
          left:'10px',
          cursor:'pointer',
          zIndex: 100
        }}>
        <img src={require('../../assets/whatsapp_new.png')} style={{
          width:'100%',
          height:'100%'
        }} />
      </a>




      <div
        class="modal fade"
        id="locationModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
                          <div class="modal-content">
                            <div class="modal-header">
                              <button
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              ></button>
                            </div>
                            <img style={{
                                  width: '250px',
                                  alignSelf: 'anchor-center'
                              
                            }} src={require('../../assets/logo_with_text.png')} />
                           

                           <div className="field-box mt-3 d-flex flex-column">
              <TextBox
                type={"text"}
                prefix={prefixImg('user')}
                place={"Name"}
                change={setFirstName}
                input_value={firstName}
                name={"first_name"}
              />
              <span
                className="err-txt"
              >
                {firstError ? firstError : " "}
              </span>
            </div>
            <div className="field-box d-flex flex-column">
              <TextBox
                type={"number"}
                prefix={prefixImg('phone')}
                place={"Phone Number"}
                change={setPhone_no}
                input_value={phone_no}
                name={"ph_number"}
              />
              <span
                className="err-txt"
              >
                {phoneError ? phoneError : " "}
              </span>
            </div>
            <div className="field-box d-flex flex-column">
              <TextBox
                type={"text"}
                prefix={prefixImg('envelope')}
                place={"Email"}
                change={inputChange}
                input_value={email}
                name={"email"}
              />
              <span
                className="err-txt"
              >
                {emailError ? emailError : " "}
              </span>
            </div>
            <div className=" mb-3  field-box d-flex flex-column">
              <TextArea
                type={"text"}
                prefix={prefixImg('comment-dots')}
                place={"How Can We Help You?"}
                change={changeLocation}
                input_value={location}
                name={"location"}
              />
              <span
                className="err-txt"
              >
                {locationError ? locationError : " "}
              </span>
            </div>

            {!BtnLoad ? (
                        <button
                          className="btn text-center px-5"
                          style={{
                            backgroundColor: Colors.Base_color,
                            fontSize: "22px",
                            color: Colors.white_color,
                            margin: '10px'
                          }}
                          onClick={(e)=>{
                            handleSubmit(e)
                          }}
                        >
                          Submit
                        </button>
                      ) : (
                        <button
                          className="btn text-center px-5"
                          style={{
                            backgroundColor: Colors.Base_color,
                            fontSize: "22px",
                            color: Colors.white_color,
                            cursor: "wait",
                          }}
                          // onClick={loginFun}
                        >
                          Loading...
                        </button>
                      )}

         

                          </div>
                        </div>
          </div>
          
                  <ToastContainer />
      
    </>
  ) 
}

export default Home;
